import type { PaymentMethod, Stripe, StripeError } from '@stripe/stripe-js';

import type { TrackingFn } from '@change-corgi/core-react/tracking';

export async function confirmStripeCardSetup(
	stripe: Stripe,
	paymentMethod: Partial<Pick<PaymentMethod, 'id'>>,
	clientSecret: string,
	trackEvent?: TrackingFn,
): Promise<StripeError | undefined> {
	const { error, setupIntent } = await stripe.confirmCardSetup(
		clientSecret,
		{
			payment_method: paymentMethod.id,
		},
		{ handleActions: false },
	);

	if (error) {
		return error;
	}

	if (setupIntent?.status === 'requires_action') {
		void trackEvent?.('pp_payment_authentication_challenge');
		const { error: actionError } = await stripe.handleNextAction({
			clientSecret,
		});
		if (actionError) {
			void trackEvent?.('pp_payment_authentication_failure');
		} else {
			void trackEvent?.('pp_payment_authentication_success');
		}
		return actionError;
	}
	return undefined;
}
